import { IonButton, IonText } from "@ionic/react"
import { useState } from "react";

interface ICancelSubContent { 
    handleCancel: ()=> Promise<void | number | undefined>,
    setShowModal: (e:boolean)=> void
}

export const CancelarSubscripcionContent: React.FC <ICancelSubContent> = ({ handleCancel, setShowModal})=>{ 
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  function closeModal() {
    try {
      handleCancel().then((res) => {
        if(res === 401){ 
          setError(true);
          setErrorMessage("Su suscripción ya ha sido cancelada, puede continuar usándola hasta el final del periodo de suscripción. No verá reflejado el cambio en su cuenta automaticamente debido a que se ah suscripto por fuera de la app, por favor contactarse con soporte.");
        } else if(res === 400){
          setError(true);
          setErrorMessage("Su suscripción ya ha sido cancelada, puede continuar usándola hasta el final del periodo de suscripción. No verá reflejado el cambio en su cuenta automaticamente debido a que se ah suscripto por fuera de la app, por favor contactarse con soporte.");
        } else {
          setShowModal(false);
        }
      });
    } catch (e:any) {
      setError(true);
      console.log(e);
      ;
    }
  }

    return(
        <>
        {!error && 
        <>
          <IonText className="cs-cancel-suscription">Cancelar suscripción</IonText>
          <IonText className="cs-cancel-suscription-subtext">
          ¿Realmente quieres cancelar la renovación automática de tu cuenta? Se dará de baja tu suscripción al finalizar el período actual.
          </IonText>
        </>
        }

        
        <div className="cs-important-container">
          {error && (
            <>
              <IonText className="cs-important-text">{errorMessage}</IonText>
              <IonButton fill="clear" className="cs-mantain-button" onClick={() => setShowModal(false)}>
                Cerrar
              </IonButton>
          </>
          )
          }
          {!error && (
            <>
          <IonText className="cs-important-text">Importante:</IonText>
          <IonText className="cs-important-subtext">
            Si cancelas, perderás acceso a todo el contenido pago de la app, incluido las técnicas que tengas marcadas como favoritas y las notas asociadas.{' '}
          </IonText>
          <IonButton className="cs-confirm-button" fill="clear" onClick={closeModal}>
            Sí, cancelar Suscripción
          </IonButton>
          <IonButton fill="clear" className="cs-mantain-button" onClick={() => setShowModal(false)}>
            No, mantener Suscripción
          </IonButton>
          </>
          )}
        </div>

        

        
        </>
    )
}